var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('manage-navegator'),_vm._v(" "),_c('div',{staticClass:"tab-content",staticStyle:{"padding-top":"40px","padding-bottom":"40px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }